import React from "react";

import { useDrawolaT } from "../../storage/i18n";

import type { CloudFileMeta } from "../types";

type Props = {
  open: boolean;
  remoteMeta: CloudFileMeta | null;
  onOverwrite: () => void;
  onLoadRemote: () => void;
  onCancel: () => void;
};

export const ConflictModal: React.FC<Props> = ({
  open,
  remoteMeta,
  onOverwrite,
  onLoadRemote,
  onCancel,
}) => {
  const t = useDrawolaT();
  if (!open) {
    return null;
  }

  return (
    <div
      className="drawOla-cloud-modal"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div className="drawOla-cloud-modal__panel drawOla-cloud-modal__panel--narrow">
        <div className="drawOla-cloud-modal__header">
          <h3 className="drawOla-cloud-modal__title">
            {t("cloud.conflictTitle")}
          </h3>
        </div>
        <div className="drawOla-cloud-modal__body">
          <p>{t("cloud.conflictBody")}</p>
          {remoteMeta && (
            <p className="drawOla-cloud-modal__meta">
              {t("cloud.conflictMeta", {
                name: remoteMeta.name,
                version: remoteMeta.version,
              })}
            </p>
          )}
        </div>
        <div className="drawOla-cloud-modal__actions">
          <button
            type="button"
            className="drawOla-cloud-modal__button drawOla-cloud-modal__button--secondary"
            onClick={onCancel}
          >
            {t("cloud.cancel")}
          </button>
          <button
            type="button"
            className="drawOla-cloud-modal__button drawOla-cloud-modal__button--secondary"
            onClick={onLoadRemote}
          >
            {t("cloud.loadRemote")}
          </button>
          <button
            type="button"
            className="drawOla-cloud-modal__button drawOla-cloud-modal__button--primary"
            onClick={onOverwrite}
          >
            {t("cloud.overwrite")}
          </button>
        </div>
      </div>
    </div>
  );
};
